export function getTopNCommonKeys(objects, n) {
    const keyFrequency = {};

    // Count occurrences of each key
    objects.forEach(obj => {
        Object.keys(obj).forEach(key => {
            if (!keyFrequency[key]) {
                keyFrequency[key] = { count: 0, value: obj[key] };
            }
            keyFrequency[key].count++;
        });
    });

    // Sort keys by frequency (highest first)
    const sortedKeys = Object.entries(keyFrequency)
        .sort((a, b) => b[1].count - a[1].count) // Sort by count descending
        .slice(0, n); // Get top N

    // Convert to desired output format
    const result = {};
    sortedKeys.forEach(([key, data]) => {
        result[key] = data.value;
    });

    return result;
}